import PortfolioInvestmentsError from '../PortfolioInvestmentsError';
class PropertyIsNotRegistered extends PortfolioInvestmentsError {
    propertyId;
    constructor(propertyId, options) {
        super('The property is not found', options);
        this.propertyId = propertyId;
    }
}
export default PropertyIsNotRegistered;
